import React, { useState } from "react";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { app } from "../../Firebase/Firebaseapp";
import {collection,addDoc, getFirestore} from "firebase/firestore";
import { useDispatch } from "react-redux";
import { SignoutUser } from "../../Redux/Slice/AutSlice";

const auth = getAuth();

const db = getFirestore(app);

const InsertAdmin = ({ setcreateUserModal }) => {
  const dispatch=useDispatch()

  const [Details, setDetails] = useState({name:"" , Email: "", Password: ""});

   
  const RegisterNewAdmin = async (Email,Password,name) => {
    await addDoc(collection(db, "AdminUser"), {
      name:name,
      email: Email,
    });
  }



  const submitform = async() => {
    
    await createUserWithEmailAndPassword(auth,Details.Email, Details.Password)
        .then((err)=>console.log(err))
        await RegisterNewAdmin(Details.Email, Details.Password,Details.name)
       await setcreateUserModal(false)
       dispatch(SignoutUser())
    
  };
  
  const handlechange = (event) => {
    setDetails((olddata) => {
      return { ...olddata, [event.target.name]: event.target.value };
    });
  };

  return (
    <div className="absolute h-[90vh] w-[100%] top-0 flex justify-center items-center backdrop-blur-sm ">
      <div className="container mx-auto py-8  ">
        <div className="w-96 mx-auto bg-white rounded shadow-lg">
          <div className="mx-16 py-4 px-8 text-black text-xl font-bold border-b border-grey-500">
            Add Admin User
          </div>
          <div className="py-4 px-8 text-center text-red-700  font-bold border-b border-grey-500">
            *After Adding New Admin you will LogOut with in 3 sec
          </div>

          <div className="py-4 px-8">
          <div className="mb-4">
              <span className="block text-balck text-sm font-bold mb-2">
                Admin Name:
              </span>
              <input
                className=" border rounded w-full py-2 px-3 text-grey-darker"
                type="text"
                name="name"
                id="Name"
                value={Details.name}
                onChange={handlechange}
                placeholder="Enter Your Name"
              />
            </div>
            <div className="mb-4">
              <span className="block text-balck text-sm font-bold mb-2">
                Email:
              </span>
              <input
                className=" border rounded w-full py-2 px-3 text-grey-darker"
                type="text"
                name="Email"
                value={Details.Email}
                onChange={handlechange}
                placeholder="Enter Your  Email"
              />
            </div>

            <div className="mb-4">
              <span className="block text-balck text-sm font-bold mb-2">
                Password:
              </span>
              <input
                className=" border rounded w-full py-2 px-3 text-grey-darker"
                type="text"
                name="Password"
                id="Email"
                value={Details.Password}
                onChange={handlechange}
                placeholder="Enter Your Password"
              />
            </div>
            

            <div className="mb-4">
              <button
                onClick={submitform}
                className="mb-2 mx-10 rounded-full py-1 px-24 bg-gradient-to-r from-green-400 to-blue-500 "
              >
                Submit
              </button>
            </div>
            <div className="mb-4">
              <button
                onClick={()=>setcreateUserModal(false)}
                className="mb-2 mx-10 rounded-full py-1 px-24 bg-gradient-to-r from-black to-red-600  text-white"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsertAdmin;
